import { render, staticRenderFns } from "./IconArrowBlue.vue?vue&type=template&id=3174c129&"
import script from "./IconArrowBlue.vue?vue&type=script&lang=js&"
export * from "./IconArrowBlue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports